<template>
  <v-container-with-title title="Marcas" :subtitle="subtitle">
    <!-- A search component to filter the brands -->
    <v-brands-search />
    <!-- The table with the brands -->
    <v-brands-table />
  </v-container-with-title>
</template>

<script>
import { mapState } from "vuex";

import VBrandsSearch from "./Search";
import VBrandsTable from "./Table";
import VContainerWithTitle from "@/components/containers/ContainerWithTitle";

export default {
  components: {
    VBrandsSearch,
    VBrandsTable,
    VContainerWithTitle
  },
  computed: {
    ...mapState("matching", ["classifications"]),
    classificationId() {
      return this.$route.params.classificationId;
    },
    classification() {
      return this.classifications.find(c => c.id === this.classificationId);
    },
    subtitle() {
      /* Show the id of the classification if we don't have the classification in the store */
      const name = this.classification
        ? this.classification.name
        : this.classificationId;
      return `Marcas de la clasificación "${name}" ordenadas de acuerdo a cuántos QMI sin QMP tienen.`;
    }
  }
};
</script>
